import { colors } from './colors';

export const borderRadius = '8px';

export const fieldBorderRadius = '4px';

export const defaultBorder = `1px solid ${colors.lightBorder}`;
